module.exports = __webpack_public_path__ + "static/media/dashboard.6369c717.svg";